import axios from 'axios';
import { API_BASE_URL, ENDPOINTS } from '../config';

const API_URL = `${API_BASE_URL}${ENDPOINTS.SEARCH_JOBS}`;

export const httpService = {
    searchJobs: async (searchParams) => {
        try {
            const token = localStorage.getItem('token');

            const response = await axios.post(API_URL, {
                token,
                ...searchParams,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.data.code === 200) {
                return { success: true, data: response.data };
            }

            return { success: false, message: response.data.message };
        } catch (error) {
            return { 
                success: false, 
                message: error.response?.data?.message || 'Erreur de communication avec l\'API.' 
            };
        }
    }
};
